import type { Tenant } from "@repo/shared-types";

/** The alias the api resolves to the caller's own personal space. */
export const PERSONAL_PATH = "/t/me";

/**
 * Where a space lives in this app. Every link to one goes through
 * here rather than building `/t/${slug}` by hand.
 *
 * A space's slug is its id, which nobody needs to read, so pages link to it
 * and never print it: a space is shown by its name. A personal space is
 * always /t/me, and the alias means a link to it opens whoever follows it
 * their own — the only thing a link to a one-member space could usefully do.
 */
export function tenantPath(tenant: Pick<Tenant, "slug" | "isPersonal">): string {
  return tenant.isPersonal ? PERSONAL_PATH : `/t/${tenant.slug}`;
}
